const DictionaryMiss = () =>
  import(
    /* webpackChunkName: "system-dictionary-miss" */ '@/pages/system/dictionary/miss/index.vue'
  )

export default {
  path: 'miss',
  meta: {
    label: 'miss',
    auth: 'miss'
  },
  component: {
    name: 'Miss',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemDictionaryMiss',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: DictionaryMiss
    }
  ]
}
